<template>
  <div class="sticky bg-slate-100 flex w-full px-2 md:px-4 lg:px-8 z-10" style="top: 0rem; padding: 1rem 0rem">
    <div class="w-full">
      <div class="flex justify-between w-full sticky">
        <!-- SM - OPEN SIDEBAR BUTTON -->

        <div class="flex items-center gap-4">
          <feather-icon class="sm:inline-flex lg:hidden cursor-pointer p-0" icon="MenuIcon" @click="openSidebar" />
          <transition>
            <div v-if="$route.meta.breadcrumb || $route.meta.pageTitle"
              class="router-header flex flex-wrap items-center md:flex gap-4">
              <div class="content-area__heading flex items-center">
                <h3 class="mr-2 text-2xl text-slate-900 flex relative">
                  {{ routeTitle }}
                </h3>
              </div>
            </div>
          </transition>
        </div>

        <div class="flex items-center gap-4">
          <!-- <router-link :to="'/organization/' + orgData.slug + '/marketplace'"
            class="grid place-content-center justify-center grid-flow-col py-3 items-center relative overflow-hidden sidebar__item">
            <vx-tooltip text="Apps" position="bottom" class="flex flex-col w-full">
              <img :src="require('@/assets/images/icons/app-marketplace/flat-icons/unified-app-launch.svg')"
                alt="app-launch" width="37px" height="37px" class="cursor-pointer" />
            </vx-tooltip>
          </router-link> -->
          <combined-drop-down />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CombinedDropDown from "./components/CombinedDropDown.vue";

import gsap from "gsap";

export default {
  name: "the-navbar-vertical",
  components: {
    CombinedDropDown,
  },

  computed: {
    routeTitle() {
      return this.$route.meta.pageTitle;
    },
    orgData() {
      return this.$store.state.organization.orgData;
    },
  },

  methods: {
    checkGrpChildrenActive(group) {
      const path = this.$route.fullPath;
      let active = false;
      const routeParent = this.$route.meta
        ? this.$route.meta.parent
        : undefined;

      if (group.submenu) {
        group.submenu.forEach((item) => {
          if (active) return true;
          if ((path == item.url || routeParent == item.slug) && item.url) {
            active = true;
          } else if (item.submenu) {
            this.checkGrpChildrenActive(item);
          }
        });
      }

      return active;
    },

    openSidebar() {
      const tl = gsap.timeline({
        defaults: {
          duration: 0.2,
          ease: "rough",
          repeat: 0,
        },
      });

      tl.fromTo(
        "#sidebarOverlay",
        0.2,
        { zIndex: 3000, opacity: 0 },
        { opacity: 0.5 }
      );

      tl.to("#mobileSidebar", 0.2, { marginLeft: "4rem" });
    },
  },
};
</script>

<style lang="scss" scoped>
.blinker {
  top: 0.75em;
  right: -0.5em;

  &-color {
    background: rgba(var(--vs-primary, "#F2C244"), 1) !important;
  }

  &-details {
    background: #fae0a0;
    left: 6em;
    top: 2em;
    width: 20em;
    border-radius: 8px;
  }
}

@media (min-width: 1201px) {
  .navbar-floating .vx-navbar {
    padding-left: 0;
    padding-right: 0;
  }
}

.organization-dropdown-container :deep(img) {
  /* Create a perfect square container for the image */
  width: 36px !important;
  height: 36px !important;
  
  /* Make the container a perfect circle */
  border-radius: 50% !important;

  /* Ensure the image fills the circle without distortion */
  object-fit: cover !important; 

  /* Prevent the icon from shrinking in a flex layout */
  flex-shrink: 0;
}
</style>